<template>
    <div class="page_">
        <navbar/>
        <div class="breadcrum_">首页 > 救援服务</div>
        <div class="con_">
          <img src="../../assets/wxmall/service.png" alt="">
          <div class="content">
            史带集团旗下的救援机构---爱思卡（ASSIST CARD）公司于1972年在瑞士成立，专注于为国际旅行者提供全面救援服务的、世界最大规模的援助组织之一，可提供365*24小时的全天候服务。通过遍布全球197个国家和地区、17,000座城市的70多万个医疗网点，可以为全球旅行者提供任何地点、任何语言、任何原因的救援服务。
          </div>
        </div>
        <footbar></footbar>
    </div>
</template>
<style lang="scss" scoped>
.page_ {
    font-size: 12px;
    .con_{
      width:1000px;
      margin:20px auto;
      padding:30px;
      display:flex;
      flex-wrap:wrap;
      border-top:1px solid #f2f2f2;
      border-bottom:1px solid #f2f2f2;
      .content{
        padding: 30px 30px 10px;
        line-height: 25px;
        text-indent: 2em;
        font-size: 16px;
      }
    }
    .breadcrum_ {
        font-size: 12px;
        color: #666666;
        width:1000px;
        margin: 34px auto 24px;
    }
}
</style>
<script>
import navbar from './components/navbar'
import footbar from './components/footbar'
import api from '@/utils/api'
export default {
    data () {
        document.title = '救援服务'
        return {
         
        }   
    },
    components: {
        navbar,
        footbar
    },
    mounted () {
    },
    methods: {
    }
}
</script>